import { api } from "./api";

/* Media upload client. Uses raw fetch for multipart (api.js wraps JSON
   only). Returns the URL the caller should store on the property/locality
   record (or wherever the image is being attached). */

export const mediaApi = {
  /* Upload a single File or Blob.
     Returns: { id, key, url, originalName, mimeType, sizeBytes, kind, createdAt } */
  /* `watermark` tiles "AbhiGhar.com" across the image server-side and keeps
     the clean original under originals/. Opt-in per call: property photos and
     gallery images pass it; employee KYC documents and brochures must not. */
  async uploadImage(file, { watermark = false } = {}) {
    if (!file) throw new Error("No file provided");
    const formData = new FormData();
    formData.append("file", file);
    const qs = watermark ? "?watermark=1" : "";
    const res = await fetch(`${api.base}/media/upload${qs}`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });
    if (!res.ok) {
      let msg = `Upload failed (${res.status})`;
      try { const j = await res.json(); if (j?.message) msg = j.message; } catch { /* swallow */ }
      throw new Error(msg);
    }
    return res.json();
  },

  async delete(id) {
    return api.delete(`/media/${id}`);
  },

  /* List media with optional kind filter.
     opts: { kind?: "image"|"video"|"document", page?, pageSize? }
     Returns: { items: [], total, page, pageSize } */
  async list(opts = {}) {
    const qs = new URLSearchParams();
    if (opts.kind && opts.kind !== "all") qs.set("kind", opts.kind);
    if (opts.page) qs.set("page", String(opts.page));
    if (opts.pageSize) qs.set("pageSize", String(opts.pageSize));
    const query = qs.toString();
    return api.get(`/media${query ? "?" + query : ""}`);
  },
};
